<template>
  <div>
    <a-form>
      <div class="title">{{ $t('admin.headerFooter.other.title') }}</div>
      <div class="row">
        <div class="every" style="width: 33%">
          <span>{{ $t('admin.headerFooter.other.font.label') }}</span>
          <div class="content">
            <div class="colorSelect colorSelectBig" @click="colorSelect('otherFont')">
              <span @click.stop="resetColor('otherFont')">{{ $t('admin.headerFooter.other.font.reset') }}</span>
              <div :style="{ background: form.otherFont }"></div>
              <img src="@/assets/icons/icon_xl.png" alt="" />
            </div>
            <div class="colorSelectPicker" v-show="showPicker" @click="showPicker = false">
              <div id="pickerOther" @click.stop></div>
            </div>
          </div>
        </div>
        <div class="every" style="width: 33%">
          <span>{{ $t('admin.headerFooter.other.navHover.label') }}</span>
          <div class="content">
            <div class="colorSelect colorSelectBig" @click="colorSelect('otherSelectFont')">
              <span @click.stop="resetColor('otherSelectFont')">{{ $t('admin.headerFooter.other.navHover.reset') }}</span>
              <div :style="{ background: form.otherSelectFont }"></div>
              <img src="@/assets/icons/icon_xl.png" alt="" />
            </div>
          </div>
        </div>
        <div class="every" style="width: 33%">
          <span>{{ $t('admin.headerFooter.other.selectBackground.label') }}</span>
          <div class="content">
            <div class="colorSelect colorSelectBig" @click="colorSelect('otherSelectBackground')">
              <span @click.stop="resetColor('otherSelectBackground')">{{ $t('admin.headerFooter.other.selectBackground.reset') }}</span>
              <div :style="{ background: form.otherSelectBackground }"></div>
              <img src="@/assets/icons/icon_xl.png" alt="" />
            </div>
          </div>
        </div>
        <div class="every" style="width: 33%; margin-top: 22px">
          <span>{{ $t('admin.headerFooter.other.favicon.label') }}</span>
          <div class="content" style="max-width: 250px;">
            <Upload 
              :fileUrl="form.favicon" 
              @uploadData="uploadData" 
              :desc="$t('admin.headerFooter.other.favicon.description')" 
              :accept="['png', 'jpg']"
            ></Upload>
          </div>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import iro from '@jaames/iro'
import Upload from '@/components/upload/index.vue'

export default {
  name: 'HeaderFooter',
  components: {
    Upload
  },
  data() {
    return {
      form: {
        favicon: '',
        otherFont: '',
        otherSelectFont: '',
        otherSelectBackground: ''
      },
      showPicker: false
    }
  },
  methods: {
    colorSelect(key) {
      this.colorKey = key
      this.showPicker = !this.showPicker
    },
    resetColor(key) {
      this.form[key] = ''
      this.$forceUpdate()
    },
    uploadData(data) {
      console.log(data)
      this.form.favicon = data.length ? data[0].url : ''
      this.$forceUpdate()
    }
  },
  computed: {
    // Your computed properties here
  },
  mounted() {
    this.boxPicker = new iro.ColorPicker('#pickerOther', {
      width: 250,
      color: 'rgb(255, 0, 0)',
      borderWidth: 1,
      borderColor: '#fff',
      layout: [
        {
          component: iro.ui.Box
        },
        {
          component: iro.ui.Slider,
          options: {
            id: 'hue-slider',
            sliderType: 'hue'
          }
        }
      ]
    })
    this.boxPicker.on('color:change', color => {
      // 将当前颜色记录为十六进制字符串
      console.log(color.hexString)
      this.form[this.colorKey] = color.hexString
      this.$forceUpdate()
    })
  }
}
</script>

<style lang="less"  scoped>
/deep/.ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }
  .row {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 24px;
    .every {
      width: 100%;
      // display: flex;
      > span {
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        display: flex;
        // width: 100px;
        padding-top: 6px;
      }
      .content {
        width: calc(100% - 100px);
        display: flex;
        margin-top: 15px;
        .preview {
          width: 100%;
          height: 75px;
          border: 9px solid #f3f4f5;
          background: #fff;
          border-radius: 4px;
          padding: 0 26px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          > img {
            height: 34px;
            background: #d8d8d8;
            border-radius: 8px;
            border: 1px solid #ebebeb;
          }
          .user {
            display: flex;
            align-items: center;
            img {
              width: 14px;
              margin-right: 3px;
            }
          }
        }
        .previewNavigation{
          justify-content: center;
          align-items: center;
          .tag{
            width: 15%;
            font-weight: 400;
            font-size: 18px;
            color: #000000;
            line-height: 1;
            text-align: left;
            font-style: normal;
            position: relative;
            text-align: center;
          }
          .tagSelect{
            color: #F27529;
            &::after{
              content: '';
              width: 23px;
              height: 3px;
              background: #F27529;
              position: absolute;
              bottom: -18px;
              left: 50%;
              margin-left: -11px;
            }
          }
        }
        .colorSelect {
          width: 62px;
          height: 35px;
          background: #fcfcfc;
          border-radius: 6px;
          border: 1px solid #e8ecf0;
          padding-right: 20px;
          box-sizing: border-box;
          position: relative;
          // margin-left: 10px;
          overflow: hidden;
          > div {
            width: 100%;
            height: 100%;
            background: #fff;
            border-radius: 0 5px 5px 0;
          }
          img {
            position: absolute;
            top: 14px;
            right: 6px;
            width: 11px;
          }
        }
        .colorSelectBig {
          min-width: 106px;
          display: flex;
          align-items: center;
          > span{
            color: #fff;
            font-size: 12px;
            cursor: pointer;
            background-color: #AFAFAF;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            padding: 0 2px;
            line-height: 1.2;
            height: 100%;
          }
        }
        .colorSelectPicker {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
      }
    }
    .must {
      &::before {
        content: '*';
        color: #ff4d4f;
        margin-left: 5px;
        width: 8px;
      }
      > span {
        width: 92px;
      }
    }
  }
}
</style>
